import React, { useState } from 'react';
import { Button, IconButton, Menu, MenuItem } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';

const FilterButtons = ({ onFilterChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (filterType) => {
    onFilterChange(filterType);
    handleClose();
  };

  return (
    <div>
      <IconButton
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <FilterListIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleMenuItemClick('all')}>Alle Kurse</MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('paid')}>Meine bezahlten Kurse</MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('free')}>Gratis Kurse</MenuItem>
      </Menu>
    </div>
  );
};

export default FilterButtons;
